export const CHECKOUT = {
  ADDRESS_CONFIRMATION: 'checkout_address_confirmation',
  ADDRESSES: 'checkout_addresses',
  BILLING_ADDRESS: 'checkout_billing_address',
  CART: 'checkout_cart',
  INSURANCE: 'checkout_insurance',
  PAYMENT_RESULT: 'checkout_payment_result',
  PAYMENT: 'checkout_payment',
  SELF: 'checkout',
  SHIPPING_ADDRESS: 'checkout_shipping_address',
  SERVICES: {
    BOUYGUES: {
      ROOT: 'checkout_services_bouygues_telecom',
      SIGN_UP: 'checkout_services_bouygues_telecom_sign_up',
      AUTH: 'checkout_services_bouygues_telecom_auth',
      PHONELINE_SETUP: 'checkout_services_bouygues_telecom_phoneline_setup',
      NOT_ELIGIBLE: 'checkout_services_bouygues_telecom_not_eligible',
    },
  },
  IN_STORE_SALES: {
    BOUYGUES_TELECOM: {
      SELF: 'checkout_in_store_sales_bouygues_telecom',
      CART: 'checkout_in_store_sales_bouygues_telecom_cart',
      ADDRESSES: 'checkout_in_store_sales_bouygues_telecom_addresses',
      PAYMENT: 'checkout_in_store_sales_bouygues_telecom_payment',
      PAYMENT_RESULT: 'checkout_in_store_sales_bouygues_telecom_payment_result',
    },
  },
  GIFT_CARDS: {
    SELF: 'checkout_gift_cards',
    BILLING_ADDRESS: 'checkout_gift_cards_billing_address',
    PAYMENT: 'checkout_gift_cards_payment',
    PAYMENT_RESULT: 'checkout_gift_cards_payment_result',
    WEBVIEW: {
      BILLING_ADDRESS: 'checkout_gift_cards_billing_address_webview',
      PAYMENT: 'checkout_gift_cards_payment_webview',
    },
  },
}
